import React, {Fragment, Suspense} from 'react';
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";

class LegacyEmailTemplates extends React.Component {

    render() {
        return (
            <LegacyFrame withHeader={false} isPageTitleNeeded={false} pageTitle={"Email Templates"} formname={"table_23"} templateType={"email"} customClass={"field-customization-container template-container"} customFrameClass={"email-template-container"}/>
        );
    }
}

export default LegacyEmailTemplates;
